var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"slider-small"},[_c('div',{staticClass:"slider-small-inner-content",style:(_vm.Image)},[_c('h1',{staticClass:"text-capitalize text-center"},[_vm._v(_vm._s(_vm.Title))]),_c('p',[_vm._v(_vm._s(_vm.Subtitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }